/**
 * Apply event listener to run fieldUpdated workflow
 * @param {Object} workflow - rowAdded workflow
 * @param {Object} eventBus - eventBus instance
 */
export default function(workflow, eventBus) {
  if (!workflow.sourceGrid)
    throw new Error('[simpleWorkflow] - missing "sourceGrid" property')

  if (!workflow.cellKey)
    throw new Error('[simpleWorkflow] - missing "cellKey" property')

  eventBus.$on(
    `simpleWorkflow-fieldUpdated-${workflow.sourceGrid}-${workflow.cellKey}`,
    async rowData => {
      const actions = workflow.actions

      if (!actions) return

      for (let idx in actions) {
        const action = actions[idx]

        switch (action.type) {
          case 'addRowTo':
            await addRowTo(action, rowData)
            break
          case 'updateUpdatedRow':
            updateUpdatedRow(workflow.sourceGrid, action, rowData)
            break
        }
      }
    }
  )
}

async function addRowTo(action, rowData) {
  let row = rowData;
  const addedRowKey = await $dgAddRow(action.gridId, { _created: true })
  const newRow = Object.assign({}, $dataGrid(action.gridId)[addedRowKey])

  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      switch (writeMethod.type) {
        case 'updatedRow':
          newRow[writeMethod.targetCell] = rowData[writeMethod.sourceCell]
          break
        case 'expression':
          try {
            const value = eval(writeMethod.expression)

            newRow[writeMethod.targetCell] = value
          } catch (err) {
            console.error(err)
          }
          break
      }
    }
  }

  $dgSetRow(action.gridId, addedRowKey, newRow)
}

function updateUpdatedRow(sourceGrid, action, rowData) {
  let row = rowData;
  const newRow = $dataGrid(sourceGrid)[rowData.rowKey]
  let item = rowData
 // console.log(item)
  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      try {
        const value = eval(writeMethod.expression)

        newRow[writeMethod.targetCell] = value
      } catch (err) {
        console.error(err)
      }
    }
  }

  $dgSetRow(sourceGrid, rowData.rowKey, newRow)
}
